import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, AfterContentInit } from '@angular/core';
import { ScheduleService } from '../../shared/services/schedule.service';
import { SessionService } from '../../shared/services/session.service';
import { CalendarService } from '../../shared/services/calendar.service';
import { SpinnerService } from '../spinner/spinner.service';
import { Log } from '../../shared/utils/log';
import { DaySlots } from '../../shared/models/schedule/day-slots.model';
import { Slot } from '../../shared/models/schedule/slot.model';
import { Utils } from '../../shared/utils/utils';

import * as moment from 'moment-timezone';
import { TranslateService } from '@ngx-translate/core';

declare var $:any;

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'day-component',
    templateUrl: 'day.component.html',
    host: { 
        '[class.col-md-4]': 'numberColumns === 5 && isFocusedDay',
        '[class.col-md-2]': 'numberColumns === 5 && !isFocusedDay', 
        '[class.col-xs-4]':'numberColumns === 3',
        '[class.col-12]': 'numberColumns === 1'
    },
    standalone: false
})
export class DayComponent implements OnInit, OnDestroy, AfterContentInit {

    @Output() public selectedTime:EventEmitter<Slot> = new EventEmitter<Slot>();
    @Input() public isFocusedDay:boolean;
    @Input() public numberColumns:number;

    public daySlots:DaySlots = null;
    public dayNumber:string;
    public dayName:string;
    public month: string;
    public viewOnly: boolean = true;
    public isScheduleFull: boolean = false;

    private _date:Date;
    @Input() public set date(value:Date) {
        if(value instanceof Date) {
            this._date = value;
            this.setup();
        } else {
            Log.error('Error, the date input on DayComponent is expecting a Date type');
        }
    }
    public get date():Date {
        return this._date;
    }

    constructor(private _scheduleService:ScheduleService,
                private _sessionService:SessionService,
                private _calendarService:CalendarService,
                private _translate: TranslateService,
                private _spinner: SpinnerService) {
                    //
    }

    ngOnInit() {
        this.viewOnly = this._sessionService.viewOnly;
    }

    ngAfterContentInit() {
        $('.chosen').attr('tabindex', '-1');
        $('.chosen').focus();
    }

    ngOnDestroy() {
        // this.unbindEvents();
    }

    protected setup() {

        this.dayNumber = this.date.getDate().toString();
        this.dayName = this._calendarService.getDayDisplayName(this.date);

        this._spinner.show();

        this._scheduleService.getScheduleSlots
                (this._sessionService.location, this._date, this._date, this._sessionService.service).subscribe(res => {
            if (res !== null) {
                let dateString:string = Utils.getShortISOYearMonthDay(this.date);
                if(res[dateString]) {
                    this.daySlots = res[dateString];
                    this.daySlots.timezone = this._sessionService.location.tzData;
                    this.daySlots.slots.forEach(slot => {
                        let startTime = new Date(moment.tz(slot.startTimestamp, this.daySlots.timezone).tz('UTC').format());
                        let now = new Date(moment.tz(Date.now(), 'UTC').format());
                        // if the slot is not expired but the time has passed lets expire it.
                        if (startTime.getTime() < now.getTime() && !slot.expired) {
                            slot.expired = true;
                            this.daySlots.totalRemainingAppointements -= slot.available;
                            if (slot.slotHour < 12) {
                                this.daySlots.remainingMorningAppointments -= slot.available;
                            } else {
                                this.daySlots.remainingAfternoonAppointments -= slot.available;
                            }
                        } else if (startTime.getTime() > now.getTime() && slot.expired) {
                            slot.expired = false;
                            this.daySlots.totalRemainingAppointements += slot.available;
                            if (slot.slotHour < 12) {
                                this.daySlots.remainingMorningAppointments += slot.available;
                            } else {
                                this.daySlots.remainingAfternoonAppointments += slot.available;
                            }
                        }
                    });
                    this.isScheduleFull = this.hasFullSchedule();
                }
                this._spinner.hide();
            } else {
                // TODO: warn user that no schedule was returned for this day?
            }
        }, error => {
            // Silent failure.
            this._spinner.hide();
        });

        this.month = 'GENERAL_REUSABLE.MONTHS.';
        switch (this.date.getMonth() + 1) {
            case 1:
                this.month += 'JANUARY';
                break;
            case 2:
                this.month += 'FEBRUARY';
                break;
            case 3:
                this.month += 'MARCH';
                break;
            case 4:
                this.month += 'APRIL';
                break;
            case 5:
                this.month += 'MAY';
                break;
            case 6:
                this.month += 'JUNE';
                break;
            case 7:
                this.month += 'JULY';
                break;
            case 8:
                this.month += 'AUGUST';
                break;
            case 9:
                this.month += 'SEPTEMBER';
                break;
            case 10:
                this.month += 'OCTOBER';
                break;
            case 11:
                this.month += 'NOVEMBER';
                break;
            case 12:
                this.month += 'DECEMBER';
                break;
        }
    }

    public focusElement(tagID: string) {
        setTimeout(function(){
            $('#' + tagID).focus();
        }, 1);
    }

    private hasFullSchedule(): boolean {
        let scheduelFull = false;
        if (this.daySlots && this.daySlots.totalRemainingAppointements <= 0) {
            this.daySlots.slots.forEach(s => {
                if (s.total > 0 && s.available <= 0) {
                    scheduelFull = true;
                }
            });
        }

        return scheduelFull;
    }
}
